import { useCallback } from 'react';

import type { QcpTicketGrant, QcpTicketPurpose } from '@/lib/qcp/ticket';
import { limuloApi } from '@/services/limuloApi';
import { useAppDispatch } from '@/store/hooks';

/**
 * Chiede UN ticket nuovo a QChinesePoker via il BFF di Limulo (`issueChinesePokerTicket`), a OGNI chiamata: nessuna cache, nessun
 * riuso. La mutation e `reset()`ata appena consumata, cosi il ticket non resta nello store di RTK Query piu del tempo di una
 * `await`. Un errore (424 capability spenta, 4xx appiattito) lo lancia chi chiama `unwrap()`: lo legge `openQcpSocket`.
 */
export function useQcpIssueTicket(): (purpose: QcpTicketPurpose) => Promise<QcpTicketGrant | null> {
  const dispatch = useAppDispatch();
  return useCallback(
    async (purpose) => {
      const richiesta = dispatch(limuloApi.endpoints.issueChinesePokerTicket.initiate({ purpose }));
      try {
        return await richiesta.unwrap();
      } finally {
        richiesta.reset();
      }
    },
    [dispatch],
  );
}
